import type { Impact, ImpactTile } from '../forest/tile';
import type { ImpactFromImpactType } from './types';
import type { ImpactType } from './units';

export function getImpactQuantity<T extends ImpactType>(impact: ImpactFromImpactType<T>): number | null;
export function getImpactQuantity(impact: Impact | ImpactTile): number | null {
  if ('value' in impact) return impact.value || 0;
  if ('numberOfTonnes' in impact) return impact.numberOfTonnes;
  if ('numberOfMeters' in impact) return impact.numberOfMeters;
  return null;
}
